import React, { useContext } from 'react';
import { UserContext } from '~/dashboard/context';
import type { Permissions } from '~/helpers/typescript';

type Props = {
  permissions: Array<keyof Permissions>;
  children: React.ReactNode;
  callbackWithPermissionRes?: (val: boolean) => unknown;
};

export const PermissionChecker = ({
  permissions,
  children,
  callbackWithPermissionRes,
}: Props) => {
  const { permissions: userPermissions } = useContext(UserContext);

  const hasAllPermissions = permissions.every(permission => userPermissions?.[permission]);

  if (callbackWithPermissionRes) {
    callbackWithPermissionRes(hasAllPermissions);
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return hasAllPermissions ? <>{children}</> : null;
};
